var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"text-center",staticStyle:{"min-height":"80vh"},attrs:{"fluid":""}},[_c('h5',{staticClass:"text-danger"},[_vm._v("Sorry, you can't do that. Please go back.")])])}
var staticRenderFns = []

export { render, staticRenderFns }